module.exports = __webpack_public_path__ + "img/dw_2.479e3dfc.png";